import { ShiftManagementEnumsAutoSchedulerExecutionStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const AutomaticScheduleStatus: Record<
  string,
  ShiftManagementEnumsAutoSchedulerExecutionStatusEnum
> = {
  SOLVING_COMPLETED: 'solving_completed',
  SOLVING_SCHEDULED: 'solving_scheduled',
  SOLVING_STARTED: 'solving_started',
  SOLVING_ACTIVE: 'solving_active',
  SOLVING_INCOMPLETE: 'solving_incomplete',
  SOLVING_FAILED: 'solving_failed',
  SOLVING_KILLED: 'solving_killed',
} as const

export const AutomaticScheduleStatusMessages = {
  solving_completed: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_completed'),
  solving_scheduled: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_scheduled'),
  solving_started: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_started'),
  solving_active: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_active'),
  solving_incomplete: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_incomplete'),
  solving_failed: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_failed'),
  solving_killed: () =>
    i18n.t('shift_management.coverage_section.automation.modal.responses.solving_killed'),
} satisfies Record<ShiftManagementEnumsAutoSchedulerExecutionStatusEnum, () => string>
